import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { SessionStorageService } from '../../services/session-storage.service';
import { Pages } from '../../consts/pages';
import { PageBase } from '../page.base';
import HwUtil from '../../utils/hw-util';
import { CheckPaymentResponse } from '../../dtos/check-payment.response.dto';
import { SubscriberInfoResponse } from '../../dtos/subscriber-info.response.dto';

@Component({
    standalone: false,
    selector: 'payment-callback',
    templateUrl: './payment-callback.component.html',
    styleUrls: ['./payment-callback.component.scss']
})

export class PaymentCallbackComponent extends PageBase {
    loaded: boolean;
    transactionId: string;
    successPayment: boolean = false;
    paymentResponse: CheckPaymentResponse;
    subscriberInfo: SubscriberInfoResponse;

    async ngOnInit() {
        this.transactionId = this.route.snapshot.queryParamMap.get('TransactionId');

        this.appInit.whenReady()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: () => {
                    this.subscriberInfo = this.appInit.initData?.subscriber;
                    this.checkPayment();
                }
            });
    }

    checkPayment() {
        this.shopService.checkPayment(this.transactionId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (result) => {
                    this.paymentResponse = result as CheckPaymentResponse;

                    if (this.paymentResponse.paymentStatus.toLowerCase() === "successful") {
                        this.successPayment = true;
                        this.sessionStorageService.clearBasket();
                        this.sessionStorageService.clearUserData();
                    }

                    this.loaded = true;
                },
                error: (err) => this.errorService.showError(err)
            });

        //this.successPayment = false;
        //this.paymentResponse = {paymentProvider: "OTPSimple", hasError: false,transactionId: "dsds", paymentStatus:"dsdsds", summary:{amount: 12, currency:{code:"", symbol:"",symbolPositionOnLeft: false}},items: [],paymentStatusMessage: ""};
        //this.loaded = true;
    }
        
    backToSummaryPage() {
        HwUtil.redirectWithoutHistory(`${window.location.origin}${Pages.landing}`);
    }    
}
